import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=620e329f&scoped=true"
import script from "./electric.vue?vue&type=script&lang=js"
export * from "./electric.vue?vue&type=script&lang=js"
import style0 from "./electric.vue?vue&type=style&index=0&id=620e329f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e329f",
  null
  
)

export default component.exports